import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {Button, Flex, Modal} from "antd";
import back from "../../images/back@3x.png";
import {clrs} from "../../constants/colors";
import {Fade} from "react-awesome-reveal";
import MyText from "../../components/UI/Text/MyText";
import HorizontalDivider from "../../components/Divider/HorizontalDivider";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import classes from "../components/Header/header.module.css";
import {FilePdfOutlined} from "@ant-design/icons";
import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import artc_Implications from '../../docs/articles/scopus/water-16-02203_compressed.pdf';
import artc_fractal_an from '../../docs/articles/scopus/urbansci-08-00131-v2 (1).pdf';
import artc_hubrid from '../../docs/articles/scopus/esee1235.pdf';
import artc_analysis from '../../docs/articles/scopus/Article.pdf';
import artc_fractal_mine from '../../docs/articles/scopus/US.pdf';
import article1 from '../../docs/articles/kok/ANALYSIS OF THE IMPACT OF SHARDING ON THE SCALABILITY .pdf';
import article2 from '../../docs/articles/kok/DEVELOPMENT OF AN AUTOMATIC MONITORING.pdf';
import article3 from '../../docs/articles/kok/ENVIRONMENTAL MONITORING IN KAZAKHSTANI.pdf';
import article4 from '../../docs/articles/kok/Forecasting of GHG Emissions from Energy.pdf';
import article5 from '../../docs/articles/kok/INTEGRATED MODEL.pdf';
import article6 from '../../docs/articles/kok/МЕТОДЫ ОПРЕДЕЛЕНИЯ ЭМИССИЙ ОТ ОСНОВНЫХ.pdf';
import article7 from '../../docs/articles/posobie/Уч пособие Экология.pdf'
import article8 from '../../docs/articles/posobie/Экологический мониторинг.pdf'
import article9 from '../../docs/articles/conf/Development_of_a_database_for_the_main_stationary_sources_of_pollution_with_regulation_of_emissions_quotas.pdf'


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


const ListArticles = () => {

    const {t} = useTranslation();

    const navigate = useNavigate();


    return (
        <Flex style={{width: "100%", minHeight: "100vh", position: "relative", backgroundImage: `url(${back})`, backgroundPosition: "center", backgroundSize: "cover", marginBottom: 50}} vertical align={"center"} justify={"flex-start"} gap={30}>
            <Header/>
            <Flex style={{width: "100%", maxWidth: "1440px", padding: 20, background: clrs.white}} align={"flex-start"} gap={20} vertical>

                <HorizontalDivider/>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText strong size={"large"}>
                        Список опубликованных статей
                    </MyText>
                </Fade>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText>
                        Пять статей в рецензируемых научных изданиях, имеющих процентиль по CiteScore в базе Scopus не менее 50 (пятилесяти):
                    </MyText>
                </Fade>

                <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={30} wrap={"wrap"}>
                    <ArticleCard name={"Implications of Water Quality Index and Multivariate Statistics for Improved Environmental Regulation in the Irtysh River Basin (Kazakhstan)"} authors={"Zhalmagambetova, U.; Assanov, D.; Neftissov, A.; Biloshchytskyi, A.; Radelyuk, I."} pdfFile={artc_Implications}/>
                    <ArticleCard name={"Fractal Analysis of Air Pollution Time Series in Urban Areas in Astana"} authors={"Biloshchytskyi, A.; Neftissov, A.; Kuchanskyi, O.; Andrashko, Y.; Biloshchytska, S.; Mukhatayev, A.; Kazambayev, I."} pdfFile={artc_fractal_an}/>
                    <ArticleCard name={"Hybrid Technico-Economical Modeling of the Mid-Term Green Economy and Low-Carbon Development Strategy of Kazakhstan"} authors={"N. Zhakiyev, N. Sagadatova, G. Ismagulova, A. Bakdolotov, and A. Biloshchytskyi"} pdfFile={artc_hubrid}/>
                    <ArticleCard name={"Analysis of the Existing Air Emissions Detection Methods for Stationary Pollution Sources Monitoring"} authors={"Neftissov, A., Biloshchytskyi, A., Kazambayev, I., Kirichenko, L., Zhalmagambetova, U., and Biloshchytska, S. Neftissov, A.; Biloshchytskyi, A.; Kazambayev, I.; Kirichenko, L.; Zhalmagambetova, U.; Biloshchytska, S."} pdfFile={artc_analysis}/>
                    <ArticleCard name={"Fractal Analysis of Mining Wastewater Time Series Parameters: Balkhash Urban Region and Sayak Ore District"} authors={"Biloshchytskyi, A.; Kuchanskyi, O.; Neftissov, A.; Andrashko, Y.; Biloshchytska, S.; Kazambayev, I."} pdfFile={artc_fractal_mine}/>
                </Flex>
                    <HorizontalDivider/>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText>
                        Шесть статей в отечественных изданиях, рекомендованных КОКНВО:
                    </MyText>
                </Fade>
                <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={30} wrap={"wrap"}>
                    <ArticleCard
                        name="ANALYSIS OF THE IMPACT OF SHARDING ON THE SCALABILITY AND EFFICIENCY OF BLOCKCHAIN TECHNOLOGIES"
                        authors="Sapar Toxanov, Saltanat Sharipova, Andrii Biloshchytskyi, Dilara Abzhanova, Batyrbek Bakytkereiuły"
                        pdfFile={article1}
                    />

                    <ArticleCard
                        name="DEVELOPMENT OF AN AUTOMATIC MONITORING SYSTEM BASED ON THE OPEN ARCHITECTURE CONCEPT"
                        authors="U. Zhalmagambetova, I. Radelyuk, M. Krykbayeva, S. Biloshchytska, L. Kirichenko"
                        pdfFile={article2}
                    />

                    <ArticleCard
                        name="ENVIRONMENTAL MONITORING IN KAZAKHSTANI CONTEXT – STATE-OF-THE-ART AND CHALLENGES FOR INDUSTRIAL REGION"
                        authors="U. Zhalmagambetova, I. Radelyuk, D. Omerbayeva, A. Neftissov, I. Kazambayev"
                        pdfFile={article3}
                    />

                    <ArticleCard
                        name="Forecasting of GHG Emissions from Energy and Industrial Sectors of Kazakhstan and Assessment of Mitigation Scenarios with High Share of Renewables"
                        authors="Nurkhat Zhakіyev, Korhan Kayışlı, İlhami Colak, Almas Kushekkaliyev, Nadezhda Sagadatova, Andrii Biloshchytskyi"
                        pdfFile={article4}
                    />

                    <ArticleCard
                        name="INTEGRATED MODEL FOR FORECASTING TIME SERIES OF ENVIRONMENTAL POLLUTION PARAMETERS"
                        authors="Andrii Biloshchytskyi, Oleksandr Kuchanskyi, Alexandr Neftissov, Svitlana Biloshchytska, Arailym Medetbek"
                        pdfFile={article5}
                    />

                    <ArticleCard
                        name="МЕТОДЫ ОПРЕДЕЛЕНИЯ ЭМИССИЙ ОТ ОСНОВНЫХ СТАЦИОНАРНЫХ ИСТОЧНИКОВ ЗАГРЯЗНЕНИЙ"
                        authors="Л. Н. Кириченко, У. К. Жалмагамбетова, М. С. Крыкбаева, Е. В. Командирова, А. А. Шимпф"
                        pdfFile={article6}
                    />

                </Flex>

                <HorizontalDivider/>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText>
                        Также были подготовлены, опубликованы и утверждены учебные пособия:
                    </MyText>
                </Fade>
                <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={30} wrap={"wrap"}>
                    <ArticleCard
                        name="Экология"
                        authors="Н. Б. Мапитов, Е. А. Бабушкина, А. В. Демина, Д. Ф. Жирнова, У. К. Жалмагамбетова, М. С. Крыкбаева"
                        pdfFile={article7}
                    />
                    <ArticleCard
                        name="Экологиялық мониторинг"
                        authors="Сергазинова З.М., Мапитов Н.Б., Жалмагамбетова У.К., Крыкбаева М.С., Казамбаев И.М., Кириченко Л.Н."
                        pdfFile={article8}
                    />
                </Flex>
                <HorizontalDivider/>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText>
                        Публикация на международной конференции, индексируемой в SCOPUS:
                    </MyText>
                </Fade>
                <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={30} wrap={"wrap"}>
                    <ArticleCard
                        name="Development of a database for the main stationary sources of pollution with regulation of emissions quotas"
                        authors="D. Abzhanova, S. Toxanov, B. Bakytkereiuly and A. Neftissov"
                        pdfFile={article9}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

const ArticleCard = ({name, authors, pdfFile}) => {
    const [open, setOpen] = useState(false);

    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        setPageNumber(1);
    }, [open]);

    function onDocumentLoadSuccess({numPages}: { numPages: number }): void {
        setNumPages(numPages);
    }

    return (
        <Fade triggerOnce={true} cascade damping={0.15}>
            <Flex style={{width: 285, height: 200, padding: 20, border: `1px solid ${clrs.whiterBlacker2}`, borderRadius: 10}} align={"flex-start"} justify={"flex-start"} vertical gap={10}>
                <MyText size={"small"} style={{color: clrs.blue, textAlign: "justify"}} strong>
                    {name}
                </MyText>
                <MyText size={"small"} style={{color: clrs.whiterBlacker}}>
                    {authors}
                </MyText>
                <Flex style={{fontSize: "0.8rem", border: "1px solid black", borderRadius: 5, padding: "5px 10px", cursor: "pointer"}} align={"center"} justify={"center"} gap={5} onClick={() => {setOpen(true)}}>
                    <FilePdfOutlined />
                    PDF
                </Flex>
                <Modal
                    maskClosable={true}
                    width={800}
                    open={open}
                    style={{
                        top: 20,
                    }}
                    onOk={() => {
                        setOpen(false)
                    }}
                    onCancel={() => {
                        setOpen(false)
                    }}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => {
                            setOpen(false)
                        }}>
                            OK
                        </Button>
                    ]}
                >
                    <Flex align={"center"} justify={"center"}
                          style={{overflowX: "auto", overflowY: "hidden", width: "100%", minHeight: 300, position: "relative"}}>
                        <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={pageNumber} width={700}/>
                        </Document>
                        <Flex style={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            top: 10,
                            zIndex: 100,
                            padding: "10px 20px",
                            backgroundColor: "white",
                            borderRadius: 10,
                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                        }} gap={15} justify={"space-between"} align={"center"}>
                            <Button disabled={pageNumber === 1} onClick={() => {
                                setPageNumber(pageNumber - 1)
                            }}>
                                {'<'}
                            </Button>
                            <MyText size={"small"}>
                                {pageNumber} / {numPages}
                            </MyText>
                            <Button disabled={pageNumber === numPages} onClick={() => {
                                setPageNumber(pageNumber + 1)
                            }}>
                                {'>'}
                            </Button>
                        </Flex>
                    </Flex>

                </Modal>
            </Flex>
        </Fade>

    );
};

const Header = () => {
    return (
        <Flex className={classes.main} style={{position: "relative"}} align={"center"} justify={"center"}>
            <div style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: 90,
                backgroundColor: clrs.whiter
            }}></div>
            <Flex className={classes.inner_main} align={"center"} justify={"flex-start"} gap={75}>
                <Link to={'/'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.main'}/></Link>
                <Link to={'/monitoring'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.monitoring'}/></Link>
                <Link to={'/about'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.aboutProject'}/></Link>
                {/*<Link className={classes.hover_text2}*/}
                {/*      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage*/}
                {/*    id={'homePage.systemTradeEmission'}/></Link>*/}
            </Flex>

        </Flex>
    );
};
export default ListArticles;